import React from 'react';
import data from "../../json/science-page.json"; // Adjust path as necessary
import Sciencedesktoppage from "@/utilities/SciencePage/SciencedesktopPage/sciencedesktoppage";

function ScienceNewVersionPage() {
  return (
    <div>
      <Sciencedesktoppage data={data} />
    </div>
  );
}

ScienceNewVersionPage.hideLayout = false;

export default ScienceNewVersionPage;
